import { Toaster } from '@devizy/ui';
import * as React from 'react';

import { I18nProvider } from '@/lib/i18n/provider';
import { TRPCProvider } from '@/lib/trpc/provider';

export function Providers({ children }: { children: React.ReactNode }): React.ReactElement {
  return (
    <TRPCProvider>
      <I18nProvider>
        {children}
        <Toaster position="top-right" />
      </I18nProvider>
    </TRPCProvider>
  );
}
